import { ref, onMounted } from '@vue/composition-api'
import {CampaignsService} from '../../services'

const usePlatform = (campaignId, data) => {

    const campaign = ref(null)
    const loading = ref(false)

    const setPlatform = async () => {
        loading.value = true;
        try {
            campaign.value = await CampaignsService.getCampaignById(campaignId).get().then(snapshot => snapshot.data())
        } catch(err) {
            console.log(err)
        } finally {
            loading.value = false
        }
    }

    onMounted(() => {
        if(data) {
            campaign.value = data
            return;
        }
        setPlatform();
    })

    return {
        campaign,
        loading
    }

}

export default usePlatform
